const ABTestingModule = {
  namespaced: true,
  state: {
    campaigns: []
  },
  actions: {
    importCampaignsFromContao ({ state }) {
      state.campaigns = window.$feconfig?.testing?.campaigns || []
      // Cleanup Campaign Cookies
      if (window.cookieNS && window.cookieNS.main) {
        const appCookie = window.cookieNS.main.getCookie('simonApp')
        if (appCookie !== '') {
          try {
            const data = JSON.parse(appCookie)
            let rewriteCookie = false
            // Find cookie entries starting with ab_
            Object.keys(data).forEach(key => {
              if (key.substring(0, 3) === 'ab_') {
                // If cookie is no longer valid or campaign no longer active => delete cookie
                if (data[key].valid < Math.round(Date.now() / 1000) || !state.campaigns.find(campaign => campaign.id === key.substring(3))) {
                  delete data[key]
                  rewriteCookie = true
                }
              }
            })
            // Rewrite remaining cookie if something was deleted
            if (rewriteCookie) {
              window.cookieNS.main.setCookie('simonApp', JSON.stringify(data), 60)
            }
          } catch (error) {
            console.log(error)
          }
        }
      }
    }
  },
  getters: {
    getCampaignConfig: (state, dispatch) => (campaignName) => {
      return state.campaigns.find(campaign => campaign.id === campaignName)
    }
  }
}

export default ABTestingModule
